import { FC } from "react";

export const PercentageChangeCell: FC<{
  change: number;
  locale: string | undefined;
}> = ({ change, locale }) => {
  const percentage = (change * 100).toLocaleString(locale, {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });

  return (
    <div
      className={`font-medium text-sm whitespace-nowrap ${change >= 0 ? "text-[#4CAF50]" : "text-[#F44336]"}`}
    >
      {`${change > 0 ? "+" : ""}${percentage}%`}
    </div>
  );
};
